import {Paper} from "@mantine/core";
import {useMemo} from "react";
import {Col, Row} from "../../components/Flex/Flex";
import Icon from "../../components/Icon/Icon";
import IconMap from "../../components/Icon/IconMap";
import {useEntityTypes} from "../../utils/api";


const ranges = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];

export default function PersonalWeapons() {
    const {weapons} = useEntityTypes(['weapons'], true);

    const projectile = useMemo(() => weapons.filter(w => w.class === "307:3"), [weapons]);
    const heavy = useMemo(() => weapons.filter(w => w.class === "307:4"), [weapons]);
    const explosive = useMemo(() => weapons.filter(w => w.class === "307:7"), [weapons]);
    const creatures = useMemo(() => weapons.filter(w => w.class === "307:8"), [weapons]);


    return (
        <div className="w-full">
            <title>Personal Weapons Ranges</title>
            <Row align="center">
                <Col><h1>Personal Weapons</h1></Col>
                <Col grow={1}/>
                <Col><a className="link no-underline" href="https://www.swcombine.com/rules/?Personal_Weapons" target="_blank" rel="noreferrer"><Icon
                    icon={IconMap.SwcRules}/> Full rules</a></Col>
            </Row>
            <Paper className="mb-3">
                <h3 className="text-center">Projectile</h3>
                <table className="w-full mb-2" style={{borderSpacing: 0}}>
                    <thead>
                    <tr>
                        <th>Weapon</th>
                        <th>Range</th>
                        {ranges.map(r => <th key={r}>{r}</th>)}
                    </tr>
                    </thead>
                    <tbody>

                    {projectile.map(weapon => <WeaponRow key={weapon.id} weapon={weapon}/>)}
                    </tbody>
                </table>
                <h3 className="text-center">Heavy</h3>
                <table className="w-full mb-2" style={{borderSpacing: 0}}>
                    <thead>
                    <tr>
                        <th>Weapon</th>
                        <th>Range</th>
                        {ranges.map(r => <th key={r}>{r}</th>)}
                    </tr>
                    </thead>
                    <tbody>

                    {heavy.map(weapon => <WeaponRow key={weapon.id} weapon={weapon}/>)}
                    </tbody>
                </table>
                <h3 className="text-center">Explosive</h3>
                <table className="w-full mb-2" style={{borderSpacing: 0}}>
                    <thead>
                    <tr>
                        <th>Weapon</th>
                        <th>Range</th>
                        {ranges.map(r => <th key={r}>{r}</th>)}
                    </tr>
                    </thead>
                    <tbody>

                    {explosive.map(weapon => <WeaponRow key={weapon.id} weapon={weapon}/>)}
                    </tbody>
                </table>
                <h3 className="text-center">Creatures</h3>
                <table className="w-full mb-2" style={{borderSpacing: 0}}>
                    <thead>
                    <tr>
                        <th>Weapon</th>
                        <th>Range</th>
                        {ranges.map(r => <th key={r}>{r}</th>)}
                    </tr>
                    </thead>
                    <tbody>

                    {creatures.map(weapon => <WeaponRow key={weapon.id} weapon={weapon}/>)}
                    </tbody>
                </table>

            </Paper>
        </div>
    )
        ;
}


const formatter = new Intl.NumberFormat(undefined, {style: "percent"});

const WeaponRow = ({weapon, reverse = false}) => {

    return (
        <tr>
            <td>{weapon.name}</td>
            <td>{weapon.optimumRange} &plusmn; {weapon.dropOff}</td>
            {ranges.map(r => {
                const delta = Math.abs(weapon.optimumRange - r);
                const chance = Math.max(0, (1 - (0.95 / (1 + Math.exp(-2 * (delta - weapon.dropOff))))) - (0.003 * delta))
                let style = {background: `hsl(${(reverse ? 1 - chance : chance) * 130} 80% 30%)`}
                if (weapon.optimumRange === r) {
                    style.border = "1px solid gold";
                }

                return <td key={r} className="text-right p-1" style={style}><small>{formatter.format(chance)}</small></td>
            })}
        </tr>
    )
}
